
        var result = require("!!../../../node_modules/css-loader/index.js!./bigbools.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./src/app/bigbools/bigbools.component.css
// module id = 483
// module chunks = 2